import { Link } from 'react-router-dom';
import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';

export default function TalentIntroPage() {
  const features = [
    {
      icon: 'ri-add-circle-line',
      title: '달란트 적립',
      description: '콘텐츠 업로드, 커뮤니티 활동, 미션 완료 등 다양한 활동으로 달란트를 적립할 수 있습니다.',
      color: 'from-green-500 to-emerald-500',
      details: [
        '콘텐츠 업로드 시 포인트 적립',
        '커뮤니티 게시글 작성 및 댓글 활동',
        '일일 미션 및 특별 미션 완료',
        '이벤트 참여 및 출석 체크'
      ]
    },
    {
      icon: 'ri-subtract-line',
      title: '달란트 사용',
      description: '적립한 달란트로 교회 상품을 구매하거나 다양한 서비스를 이용할 수 있습니다.',
      color: 'from-red-500 to-rose-500',
      details: [
        'MUST몰에서 교회 상품 구매',
        '프리미엄 콘텐츠 열람',
        '특별 이벤트 참여권 구매',
        '교회 행사 티켓 예약'
      ]
    },
    {
      icon: 'ri-wallet-line',
      title: '달란트 충전',
      description: '현금으로 달란트를 충전하여 더 많은 혜택을 누릴 수 있습니다.',
      color: 'from-teal-500 to-cyan-500',
      details: [
        '다양한 결제 수단 지원',
        '충전 금액별 보너스 제공',
        '안전한 결제 시스템',
        '즉시 충전 및 사용 가능'
      ]
    },
    {
      icon: 'ri-heart-line',
      title: '기부·헌금',
      description: '달란트로 교회에 헌금하거나 선교 단체에 기부할 수 있습니다.',
      color: 'from-pink-500 to-rose-500',
      details: [
        '교회 헌금 (십일조, 감사헌금 등)',
        '선교 단체 후원',
        '구제 기금 기부',
        '기부 내역 자동 관리'
      ]
    },
    {
      icon: 'ri-gift-line',
      title: '선물하기',
      description: '다른 성도들에게 달란트를 선물하여 사랑을 나눌 수 있습니다.',
      color: 'from-purple-500 to-indigo-500',
      details: [
        '개인 간 달란트 전송',
        '축하 메시지와 함께 선물',
        '그룹 선물 기능',
        '선물 내역 확인'
      ]
    },
    {
      icon: 'ri-bank-card-line',
      title: '환급 신청',
      description: '사용하지 않은 달란트를 현금으로 환급받을 수 있습니다.',
      color: 'from-blue-500 to-indigo-500',
      details: [
        '최소 환급 금액 이상 신청 가능',
        '본인 계좌로 안전하게 입금',
        '환급 수수료 최소화',
        '빠른 처리 (영업일 기준 3일)'
      ]
    },
    {
      icon: 'ri-trophy-line',
      title: '미션 완료',
      description: '다양한 미션을 완료하고 보너스 달란트를 획득하세요.',
      color: 'from-yellow-500 to-orange-500',
      details: [
        '일일 미션 (출석, 콘텐츠 시청 등)',
        '주간 미션 (커뮤니티 활동)',
        '특별 미션 (이벤트 참여)',
        '달성도에 따른 보너스 지급'
      ]
    },
    {
      icon: 'ri-coupon-3-line',
      title: '쿠폰 등록',
      description: '프로모션 쿠폰을 등록하여 추가 달란트를 받을 수 있습니다.',
      color: 'from-orange-500 to-red-500',
      details: [
        '이벤트 쿠폰 코드 입력',
        '제휴 교회 쿠폰 사용',
        '친구 추천 쿠폰',
        '시즌별 특별 쿠폰'
      ]
    },
    {
      icon: 'ri-bar-chart-line',
      title: '통계 보기',
      description: '달란트 사용 내역과 통계를 한눈에 확인할 수 있습니다.',
      color: 'from-indigo-500 to-purple-500',
      details: [
        '월별/연도별 적립 현황',
        '카테고리별 사용 분석',
        '달란트 흐름 그래프',
        '목표 설정 및 달성률 확인'
      ]
    }
  ];

  const benefits = [
    {
      icon: 'ri-shield-check-line',
      title: '안전한 관리',
      description: '블록체인 기반의 안전한 포인트 관리 시스템'
    },
    {
      icon: 'ri-refresh-line',
      title: '실시간 적립',
      description: '활동 즉시 달란트가 적립되어 바로 사용 가능'
    },
    {
      icon: 'ri-community-line',
      title: '커뮤니티 혜택',
      description: '교회 공동체 내에서 다양한 혜택 제공'
    },
    {
      icon: 'ri-vip-crown-line',
      title: '등급별 보너스',
      description: '활동량에 따른 등급 시스템과 추가 혜택'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      <Navbar />
      
      <div className="pt-32 pb-24">
        {/* Hero Section */}
        <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-20">
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-2xl mb-6">
              <i className="ri-coin-line text-4xl text-white"></i>
            </div>
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              달란트 포인트 시스템
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              신앙 활동으로 적립하고, 교회 공동체 안에서 사용하는<br />
              특별한 포인트 시스템입니다
            </p>
          </div>
        </div>

        {/* Main Features */}
        <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-20">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            달란트로 할 수 있는 모든 것
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {features.map((feature, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300"
              >
                <div className={`w-16 h-16 bg-gradient-to-br ${feature.color} rounded-xl flex items-center justify-center mb-6`}>
                  <i className={`${feature.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {feature.description}
                </p>
                <ul className="space-y-3">
                  {feature.details.map((detail, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <i className="ri-check-line text-teal-600 text-lg mt-0.5"></i>
                      <span className="text-sm text-gray-700">{detail}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Benefits Section */}
        <div className="bg-gradient-to-br from-teal-50 to-emerald-50 py-20 mb-20">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
              달란트의 특별한 장점
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {benefits.map((benefit, index) => (
                <div
                  key={index}
                  className="bg-white rounded-2xl p-8 text-center hover:shadow-lg transition-all duration-300"
                >
                  <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className={`${benefit.icon} text-3xl text-teal-600`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">
                    {benefit.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* How It Works */}
        <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-20">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
            달란트 사용 방법
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl font-bold text-white">1</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">회원가입</h3>
              <p className="text-sm text-gray-600">MUST에 가입하고 교회를 선택하세요</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl font-bold text-white">2</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">활동하기</h3>
              <p className="text-sm text-gray-600">콘텐츠 업로드, 커뮤니티 참여로 적립</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl font-bold text-white">3</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">달란트 확인</h3>
              <p className="text-sm text-gray-600">마이페이지에서 포인트 확인</p>
            </div>
            <div className="text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-emerald-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl font-bold text-white">4</span>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">사용하기</h3>
              <p className="text-sm text-gray-600">상품 구매, 헌금, 선물 등 자유롭게 사용</p>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <div className="bg-gradient-to-br from-teal-600 to-emerald-600 rounded-3xl p-12 text-center text-white">
            <h2 className="text-4xl font-bold mb-4">
              지금 바로 달란트를 시작하세요
            </h2>
            <p className="text-xl text-teal-100 mb-8">
              신앙 활동으로 포인트를 적립하고 다양한 혜택을 누리세요
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/talent"
                className="px-8 py-4 bg-white text-teal-600 font-bold rounded-xl hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap inline-block"
              >
                내 달란트 확인하기
              </Link>
              <Link
                to="/auth/signup"
                className="px-8 py-4 bg-teal-700 text-white font-bold rounded-xl hover:bg-teal-800 transition-colors cursor-pointer whitespace-nowrap inline-block border-2 border-white/30"
              >
                회원가입하기
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
